<template>
    <svg
        viewBox="0 0 78 78"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M65.8125 14.625H12.1875C8.14856 14.625 4.875 17.8986 4.875 21.9375V56.0625C4.875 60.1014 8.14856 63.375 12.1875 63.375H65.8125C69.8514 63.375 73.125 60.1014 73.125 56.0625V21.9375C73.125 17.8986 69.8514 14.625 65.8125 14.625Z"
            :fill="`url(#${uniqueIds[0]})`" />
        <path
            d="M4.875 46.3125V56.0625C4.875 60.1014 8.14856 63.375 12.1875 63.375H65.8125C69.8514 63.375 73.125 60.1014 73.125 56.0625V46.3125H37.7812L36.5625 48.75L34.125 46.3125H4.875Z"
            :fill="`url(#${uniqueIds[1]})`" />
        <path
            d="M32.321 42.1115C30.4782 39.5143 26.6221 39.6045 24.911 42.2931C20.6478 48.9742 13.7874 59.7102 11.4072 63.3323C11.6644 63.3592 11.924 63.375 12.1872 63.375H41.7846C43.4762 63.375 45.0167 62.6706 46.1038 61.5432L32.321 42.1115Z"
            :fill="`url(#${uniqueIds[2]})`" />
        <path
            d="M67.3843 61.1569C66.0681 62.5219 64.2034 63.375 62.1559 63.375H25.3496C28.2015 59.0363 36.5499 45.9713 41.7296 37.8544C43.8015 34.6003 48.4693 34.4906 50.6996 37.635L67.3843 61.1569Z"
            :fill="`url(#${uniqueIds[3]})`" />
        <path
            d="M20.1094 21.9375C18.6548 21.9375 17.2599 22.5153 16.2313 23.5438C15.2028 24.5724 14.625 25.9673 14.625 27.4219C14.625 28.8764 15.2028 30.2714 16.2313 31.2999C17.2599 32.3284 18.6548 32.9062 20.1094 32.9062C21.5639 32.9062 22.9589 32.3284 23.9874 31.2999C25.0159 30.2714 25.5938 28.8764 25.5938 27.4219C25.5938 25.9673 25.0159 24.5724 23.9874 23.5438C22.9589 22.5153 21.5639 21.9375 20.1094 21.9375Z"
            :fill="`url(#${uniqueIds[4]})`" />
        <defs>
            <linearGradient
                :id="uniqueIds[0]"
                x1="39"
                y1="63.375"
                x2="39"
                y2="14.625"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#3CB5EA" />
                <stop
                    offset="1"
                    stop-color="#7DDEFB" />
            </linearGradient>
            <linearGradient
                :id="uniqueIds[1]"
                x1="39"
                y1="109.043"
                x2="39"
                y2="34.164"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#155CDE" />
                <stop
                    offset="0.278"
                    stop-color="#1F7FE5" />
                <stop
                    offset="0.569"
                    stop-color="#279CEB" />
                <stop
                    offset="0.82"
                    stop-color="#2CAFEF" />
                <stop
                    offset="1"
                    stop-color="#2EB5F0" />
            </linearGradient>
            <linearGradient
                :id="uniqueIds[2]"
                x1="28.7561"
                y1="69.2433"
                x2="28.7561"
                y2="22.1532"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#155CDE" />
                <stop
                    offset="0.278"
                    stop-color="#1F7FE5" />
                <stop
                    offset="0.569"
                    stop-color="#279CEB" />
                <stop
                    offset="0.82"
                    stop-color="#2CAFEF" />
                <stop
                    offset="1"
                    stop-color="#2EB5F0" />
            </linearGradient>
            <linearGradient
                :id="uniqueIds[3]"
                x1="46.367"
                y1="87.4088"
                x2="46.367"
                y2="28.0264"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#155CDE" />
                <stop
                    offset="0.278"
                    stop-color="#1F7FE5" />
                <stop
                    offset="0.569"
                    stop-color="#279CEB" />
                <stop
                    offset="0.82"
                    stop-color="#2CAFEF" />
                <stop
                    offset="1"
                    stop-color="#2EB5F0" />
            </linearGradient>
            <linearGradient
                :id="uniqueIds[4]"
                x1="20.1094"
                y1="32.9062"
                x2="20.1094"
                y2="21.9375"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#F2FBFE" />
                <stop
                    offset="1"
                    stop-color="#F4FCFE" />
            </linearGradient>
        </defs>
    </svg>
</template>

<script>
import { getRandomId } from '../../utils/helpers.js';

const ICONS_URL_IDS_NUMBER = 5;

export default {
    name: 'SbsImageStubIcon',
    computed: {
        uniqueIds() {
            return new Array(ICONS_URL_IDS_NUMBER)
                .fill('')
                .map(getRandomId);
        },
    },
};
</script>
